import React from 'react';

import DateTab from '../DOB/date';
import Input from '../input/index';
import ReactPicker from '../DOB/Reactdatepicker';

import Aux from '../../atom/children';
import Button from '../../atom/button/button';
import moment from 'moment';
const SerchCom = (props) => {
    console.log("props from search===>>>", props);
    const onBlur = (name, value) => {
        props.validate(name, value)
    }
    const changeHandler = (name, value) => {
        props.onChange(name, value)
    }

    let option = [{ label: "name", value: "name" }];
    let { schameName, startDOB, endDOB } = props.state;
    let { schameNameError, startDOBError, endDOBError } = props.error;

    return (
        <div className="col-md-12 padd0">
            <div className="row">
                <div className="col-md-10 padd0">
                    <div className="row">

                        <div className="col-md-4">
                            <Input
                                margin="nonBGtext"
                                name="schameName"
                                onChange={changeHandler}
                                onBlur={onBlur}
                                value={schameName}
                                errorMSg={schameNameError}
                                searchIcon={true}
                                placeholder="Search"
                                label="Search " />
                        </div>

                        <Aux>
                            <div className="col-md-3">
                                {/* <DateTab
                                    placeholder="Enter Start Date"
                                    margin="nonBGtext"
                                    label="Start Date"
                                    name={`startDOB`}
                                    onChange={changeHandler}
                                    onBlur={onBlur}
                                    value={startDOB}
                                    icon={true}
                                    errorMSg={startDOBError}
                                /> */}
                                <ReactPicker
                                    placeholder="Enter Start Date"
                                    margin="nonBGtext"
                                    label="Start Date"
                                    value={startDOB}
                                    onChange={changeHandler}
                                    name={`startDOB`}
                                    icon={true}
                                    onBlur={onBlur}
                                    maxDate={new Date()}
                                    errorMSg={startDOBError}
                                />
                            </div>
                            <div className="col-md-3">
                                <ReactPicker
                                    placeholder="Enter End Date"
                                    margin="nonBGtext"
                                    label="End Date"
                                    value={endDOB}
                                    onChange={changeHandler}
                                    name={`endDOB`}
                                    icon={true}
                                    onBlur={onBlur}
                                    maxDate={new Date()}
                                    errorMSg={endDOBError}
                                />
                                {/* <DateTab
                                    margin="nonBGtext"
                                    placeholder="Enter End Date"
                                    label="End Date"
                                    name={`endDOB`}
                                    onChange={changeHandler}
                                    onBlur={onBlur}
                                    value={endDOB}
                                    errorMSg={endDOBError}
                                    icon={true}
                                /> */}
                            </div>
                            <div className="col-md-2" style={{ marginTop: "17px" }} >
                                <Button name="Go" btnloader={props.loader} onClick={props.btnClick} />
                            </div>
                        </Aux>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SerchCom